import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

function RequireGuest({ children }) {
  const token = useSelector((state) => state.auth.token);
  if (token) {
    return <Navigate to="/wallet" replace />;
  }
  return children;
}

export default RequireGuest;
